module.exports = __webpack_public_path__ + "media/money.148d0b56.mp3";